export const countryCode = /^[1-9]{1,3}$/;
export const phoneNumber = /^\d{4,12}$/;
export const zipCode = /^[A-Za-z0-9][A-Za-z0-9\s-]{2,9}$/;
export const email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const url = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;
export const tin = /^\d{2}-\d{7}$/;
